export class CorporateMatching {
  public selected: string;
  public corporateSearch: {
    text: string;
    val: string;
  }[] = [];
}
